import { FC, JSX, useEffect, useRef, useState } from 'react';

import { Button, Flex, Form } from 'antd';
import ReactSignatureCanvas from 'react-signature-canvas';

import styles from './DebtsSignature.module.scss';

import { DebtsSignatureCanvas } from '../debts-signature-canvas';

export const DebtsSignature: FC = (): JSX.Element => {
	const sigRef = useRef<ReactSignatureCanvas | null>(null);
	const containerRef = useRef<HTMLDivElement | null>(null);

	const form = Form.useFormInstance();

	const [canvasWidth, setCanvasWidth] = useState(400);

	useEffect(() => {
		const updateWidth = (): void => {
			if (containerRef.current) {
				setCanvasWidth(containerRef.current.offsetWidth);
			}
		};
		updateWidth();
		window.addEventListener('resize', updateWidth);
		return () => window.removeEventListener('resize', updateWidth);
	}, []);

	const handleClear = (): void => {
		form.setFieldValue(['borrowerSignature', 'signature'], undefined);
		sigRef.current?.clear();
	};

	const handleSaveSignature = (): void => {
		form.setFieldValue(['borrowerSignature', 'signature'], sigRef.current);
	};

	return (
		<>
			<Flex align="center" justify="space-between" style={{ width: '100%' }}>
				<span className={styles['label']}>Signature</span>
				<Button
					className={styles['clear-btn']}
					type="default"
					variant="outlined"
					onClick={handleClear}
				>
					Clear
				</Button>
			</Flex>
			<div ref={containerRef} className={styles['container']}>
				<Flex vertical>
					<DebtsSignatureCanvas
						canvasProps={{ width: canvasWidth, height: 127 }}
						handleSaveSignature={handleSaveSignature}
						sigRef={sigRef}
					/>
				</Flex>
			</div>
		</>
	);
};
